import { useState } from 'react';

import { useLocaleStoreQuery } from 'hooks/useLocaleStoreQuery/useLocaleStoreQuery';

export const useWantedHistorySearchQuery = () => {
  const {
    storedQueries: { wantedHistory: wantedHistoryQuery },
  } = useLocaleStoreQuery();

  const [tkdSearchQuery, setTkdSearchQuery] = useState(wantedHistoryQuery?.tkd?.label || '');
  const [executorSearchQuery, setExecutorSearchQuery] = useState(wantedHistoryQuery?.query?.label || '');
  const [ownerSearchQuery, setOwnerSearchQuery] = useState(wantedHistoryQuery?.posiadacz?.label || '');

  const clearSearchQueries = () => {
    setTkdSearchQuery('');
    setExecutorSearchQuery('');
    setOwnerSearchQuery('');
  };

  return {
    tkdSearchQuery,
    setTkdSearchQuery,
    executorSearchQuery,
    setExecutorSearchQuery,
    ownerSearchQuery,
    setOwnerSearchQuery,
    clearSearchQueries,
  };
};
